import { register } from "@rill/loader";

register(
  {
    name: "listCompetitions",
    meta: ["competition"],
  },
  async ({ api }, opts = {}) => {
    const res = await api("competition", {
      query: {
        limit: false,
        sort: { date: -1 },
        fields: ["_id", "name", "finished", "date"],
        proxyAthlete: opts.proxyAthlete,
      },
    });

    return await res.json();
  }
);

register(
  {
    name: "competitionsVolume",
    meta: ["competition"],
  },
  async ({ api }, opts = {}) => {
    const res = await api("competition", {
      query: {
        limit: false,
        sort: { date: -1 },
        finished: true,
        fields: ["_id", "date", "type", "attempts", "wilks"],
        proxyAthlete: opts.proxyAthlete,
      },
    });

    return await res.json();
  }
);

register(
  {
    name: "editCompetition",
    meta: ["competition"],
  },
  async ({ locals, api, assert }, { competition, proxyAthlete }) => {
    if (!competition) return {};
    const res = await api("competition", {
      query: { _id: competition, proxyAthlete },
    });
    const doc = (await res.json())[0];
    assert(doc, 400, "Unable to find competition, it may have been deleted.");
    return doc;
  }
);
